import { useState } from 'react'
import { applyTheme, currentTheme, writeStoredTheme, type Theme } from '../lib/theme'

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  )
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => currentTheme())
  const flip = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    applyTheme(next)
    writeStoredTheme(next)
  }
  const toDark = theme === 'light'
  return (
    <button
      type="button"
      onClick={flip}
      aria-label={toDark ? 'Koyu temaya geç' : 'Açık temaya geç'}
      title={toDark ? 'Koyu tema' : 'Açık tema'}
      className="p-1.5 rounded border border-border bg-surface-2 text-text-dim hover:text-text hover:bg-surface"
    >
      {toDark ? <MoonIcon /> : <SunIcon />}
    </button>
  )
}
